import React, { useState } from 'react';
import { Navbar as NavbarBootstrap, Nav, Container, NavDropdown } from 'react-bootstrap';
import logo from 'assets/img/GAR_logo.png';
import { useNavigate } from 'react-router-dom';
import DropMenu from './DropMenu/DropMenu';
import styles from './Navbar.module.scss';
import './ExtraStyle/dropStyle.scss';
import SearchBar from './SearchBar/SearchBar';
export default function Navbar(props) {
	//const handleNavigate = useNavigate()
	const [seletedDropdown, setSelectedDropdown] = useState(null);

	const handleNavigate = (link) => {
        //e.preventDefault();
        /* const encodedSearchText = encodeURIComponent(searchText);
        const absoluteURL = `/search/?keywords=${encodedSearchText}` */;
        if (link) {
            window.location.href = link;
        }
    };

	return (
		<NavbarBootstrap bg='light' expand='lg' onMouseLeave={() => setSelectedDropdown(null)}>
			<Container fluid>
				<NavbarBootstrap.Brand 
					onMouseEnter={() =>
						setSelectedDropdown(null)
					}
					className={`${styles.brand}`}
				>
					<a href='/'>
					<img
						src={logo}
						height='70'
						className='d-inline-block align-top'
						alt='React Bootstrap logo'
					/>
					</a>
				</NavbarBootstrap.Brand>
				<NavbarBootstrap.Toggle
					aria-controls='basic-navbar-nav'
					className='ms-auto'
				/>
				<NavbarBootstrap.Collapse id='basic-navbar-nav'>
					{/* <SearchBar /> */}
					<Nav className='ms-auto my-2 my-lg-0'>
						<Nav.Link href='/'
							onMouseEnter={() =>
								setSelectedDropdown(null)
							}>
							HOME
						</Nav.Link>
						<NavDropdown
							title="ABOUT US"
							id="basic-nav-dropdown-about-us"
							show={seletedDropdown === 'about_us'}
							onMouseEnter={() =>
								setSelectedDropdown('about_us')
							}
							onToggle={() =>handleNavigate('/about_us')}
							className={`${styles.navdd}`}>
							<DropMenu setSelectedDropdown={setSelectedDropdown} seletedDropdown={seletedDropdown} />
						</NavDropdown>
						<NavDropdown
							title="COLLECTIONS"
							id="basic-nav-dropdown"
							show={seletedDropdown === 'collections'}
							onMouseEnter={() =>
								setSelectedDropdown('collections')
							}
							onToggle={() => handleNavigate('/collections')}
							className={`${styles.navdd}`}>
							<DropMenu setSelectedDropdown={setSelectedDropdown} seletedDropdown={seletedDropdown} />
						</NavDropdown>
						<NavDropdown
							title="RESEARCH"
							id="basic-nav-dropdown"
							show={seletedDropdown === 'research'}
							onMouseEnter={() =>
								setSelectedDropdown('research')
							}
							onToggle={() => handleNavigate('/research')}
							className={`${styles.navdd}`}>
							<DropMenu setSelectedDropdown={setSelectedDropdown} seletedDropdown={seletedDropdown} />
						</NavDropdown>
						<Nav.Link href='/contact_us'
							onMouseEnter={() =>
								setSelectedDropdown(null)
							}>
							GET INVOLVED
						</Nav.Link>
					</Nav>
				</NavbarBootstrap.Collapse>
			</Container>
		</NavbarBootstrap>
	);
}
